export const categoriesOfTheWeek: { week: number; slug: string }[] = [
    { week: 1, slug: 'italienisch' },
    { week: 2, slug: 'fruhstuck' },
    { week: 3, slug: 'kaffee' },
    { week: 4, slug: 'burger' },
    { week: 5, slug: 'bier' },
    { week: 6, slug: 'schnitzel' },
    { week: 7, slug: 'kebap' },
    { week: 8, slug: 'steak' },
    { week: 9, slug: 'menu' },
    { week: 10, slug: 'asiatisch' },
    { week: 11, slug: 'wein' },
    { week: 12, slug: 'afghanisch' },
    { week: 13, slug: 'tee' },
    { week: 14, slug: 'persisch' },
    { week: 15, slug: 'agyptisch' },
    { week: 16, slug: 'vietnamesisch' },
    { week: 17, slug: 'sushi' },
    { week: 18, slug: 'eis' },
    { week: 19, slug: 'buschenschank' },
    { week: 20, slug: 'pizza' },
    { week: 21, slug: 'meeresfruchte' },
    { week: 22, slug: 'spritzer' },
    { week: 23, slug: 'pasta' },
    { week: 24, slug: 'nepalesisch' },
    { week: 25, slug: 'indisch' },
    { week: 26, slug: 'osterreichisch' },
    { week: 27, slug: 'franzosisch' },
    { week: 28, slug: 'amerikanisch' },
    { week: 29, slug: 'wurstel' },
    { week: 30, slug: 'vegetarisch' },
    { week: 31, slug: 'sport' },
    { week: 32, slug: 'cocktails' },
    { week: 33, slug: 'thailandisch' },
    { week: 34, slug: 'mexikanisch' },
    { week: 35, slug: 'spanisch' },
    { week: 36, slug: 'japanisch' },
    { week: 37, slug: 'chinesisch' },
    { week: 38, slug: 'koreanisch' },
    { week: 39, slug: 'suesses' },
    { week: 40, slug: 'konditorei' },
    { week: 41, slug: 'pubquiz' },
    { week: 42, slug: 'backerei' },
    { week: 43, slug: 'allyoucaneat' },
    { week: 44, slug: 'live-musik' },
    { week: 45, slug: 'vegan' },
    { week: 46, slug: 'maroni' },
    { week: 47, slug: 'balkan' },
    { week: 48, slug: 'bowls' },
    { week: 49, slug: 'gluhwein' },
    { week: 50, slug: 'shisha' },
    { week: 51, slug: 'club-disco' },
    { week: 52, slug: 'darts' },
];

export function getCurrentWeekSlug(): string | null {
    const date = new Date();
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const isoWeek = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);

    const entry = categoriesOfTheWeek.find(c => c.week === isoWeek);
    return entry ? entry.slug : null;
}
